module.exports = __webpack_public_path__ + "media/stockholm/windows-6e8ac729.jpg";